import React, { useState } from 'react';
import styles from './styles.module.scss';
import cN from 'classnames';
import Spinner from '@features/ui/Spinner';
import TicketRuleAbnormal from '@features/TicketRuleAbnormal';
import { I_FareRuleInfo } from '@interfaces/api/fareruleinfo';
// import { sortData } from "@utils/utils"


interface I_FareRuleDetailProps extends I_FareRuleInfo {
    isLoading: boolean;
}


//詳細票規光箱樣式
const FareRuleDetail = (props: I_FareRuleDetailProps) => {
    const moduleName = 'ticketRule';

    const { isLoading, FareRules } = props;

    console.log("props", JSON.stringify(props));
    const [curTabIndex, setCurTabIndex] = useState(0);
    if (isLoading) return <Spinner />;
    if (!FareRules) return <TicketRuleAbnormal />;

    return (
        <>
            <div className={styles.fareRulesSubtitle}>混艙請注意下方有2組票規，規則從嚴</div>

            {FareRules?.length > 1 &&
                (
                    <ul className={styles.typeBtn} >
                        {FareRules.map((fareRule, i) => {
                            return (
                                <li
                                    key={fareRule.FareBasis}
                                    className={cN({
                                        [`${styles['active']}`]: curTabIndex === i,
                                    })}
                                    onClick={() => setCurTabIndex(i)}
                                >
                                    {fareRule.FareBasis}
                                </li>
                            )
                        })}
                    </ul>
                )
            }
            <div className={cN(moduleName, styles[`${moduleName}`])} >
                {
                    FareRules &&
                    <>
                        <div className={styles.fareBasis}>票價FareBasis: {FareRules[curTabIndex]?.FareBasis} / 票規指令：</div>
                        {FareRules[curTabIndex]?.FareRuleDetails.map((fareRuleDetail, i) => {
                            return (
                                <div className={styles.col} key={i}>
                                    <div className={styles.title}>{fareRuleDetail.Category}{fareRuleDetail.Content}</div>
                                    <div className={styles.content}>{fareRuleDetail.ChtContent}中文詳細票規</div>
                                </div>
                            )
                        })}
                    </>
                }
            </div>

        </>
    )
};

export default FareRuleDetail;
